'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ListAdapter2 = require('./ListAdapter');

var _ListAdapter3 = _interopRequireDefault(_ListAdapter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeyedListAdapter = function (_ListAdapter) {
  _inherits(KeyedListAdapter, _ListAdapter);

  function KeyedListAdapter() {
    var itemKeyPropName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'key';

    _classCallCheck(this, KeyedListAdapter);

    var _this = _possibleConstructorReturn(this, (KeyedListAdapter.__proto__ || Object.getPrototypeOf(KeyedListAdapter)).call(this));

    _this.itemKeyPropName = itemKeyPropName;
    return _this;
  }

  _createClass(KeyedListAdapter, [{
    key: '_getKeyValueItem',
    value: function _getKeyValueItem(key, value) {
      var _ref;

      var itemKeyPropName = this.itemKeyPropName;
      // istanbul ignore next

      var _props$itemValuePropN = this.props.itemValuePropName,
          itemValuePropName = _props$itemValuePropN === undefined ? 'value' : _props$itemValuePropN;

      if (typeof value === 'object' && itemValuePropName in value) {
        if (value[itemKeyPropName] === key) {
          return value;
        } else {
          return _extends(_defineProperty({}, itemKeyPropName, key), value);
        }
      }
      return _ref = {}, _defineProperty(_ref, itemKeyPropName, key), _defineProperty(_ref, itemValuePropName, value), _ref;
    }
  }]);

  return KeyedListAdapter;
}(_ListAdapter3['default']);

exports['default'] = KeyedListAdapter;


// WEBPACK FOOTER //
// ./src/modules/autosuggest/KeyedListAdapter.js